import * as tslib_1 from "tslib";
import { Base } from '../../components/base-component';
import { AnalyticsService } from '../../services/analytics.service';
import './form-item-win-a-car.component.scss';
var FormItemWinACar = /** @class */ (function (_super) {
    tslib_1.__extends(FormItemWinACar, _super);
    function FormItemWinACar(element) {
        return _super.call(this, element) || this;
    }
    FormItemWinACar.prototype.init = function () {
        this.form = this.element.querySelector('form');
        this.submitBtn = this.element.querySelector('.js-win-a-car__button');
    };
    FormItemWinACar.prototype.bindEvents = function () {
        var _this = this;
        this.submitBtn.addEventListener('click', function (event) {
            var _button = event.target;
            var _form = _button.closest('form');
            var formFields = _form.querySelectorAll('input, select');
            _this.validationService.validate(formFields);
            var valid = Array.from(_form.querySelectorAll(".form__group--error"));
            if (valid.length == 0) {
                _this.submitForm(_form);
            }
        });
        if (this.form) {
            var _formFields = Array.from(this.form.querySelectorAll("input, select, textarea"));
            if (_formFields) {
                _formFields.forEach(function (pEement) {
                    pEement.addEventListener('blur', function (pEvent) {
                        _this.validationService.validateBlur(pEvent.currentTarget);
                    });
                });
            }
        }
    };
    FormItemWinACar.prototype.submitForm = function (form) {
        // success screens
        var loader = form.querySelector('.form__loader--container');
        var thankYou = form.querySelector('.form__thankyou--container');
        var fieldsContainer = form.querySelector('.form__fields--container');
        var success = form.querySelector('.form__success--container');
        var error = form.querySelector('.form__error--container');
        var postData = '';
        var _firstName = this.form.querySelector('input[name=first-name]');
        if (_firstName) {
            postData += 'firstname=' + _firstName.value;
        }
        var _lastName = this.form.querySelector('input[name=last-name]');
        if (_lastName) {
            postData += '&surname=' + _lastName.value;
        }
        var _idNumber = this.form.querySelector('input[name=id-number]');
        if (_idNumber) {
            postData += '&saId=' + _idNumber.value;
        }
        var _phoneNumber = this.form.querySelector('input[name=phone-number]');
        if (_phoneNumber) {
            postData += '&contact=' + _phoneNumber.value;
        }
        // loader + hide form
        loader.classList.add('active');
        fieldsContainer.classList.add('hidden');
        // variables
        var analyticsService = new AnalyticsService();
        var url = this.baseUrl + "/services/carcampaignservice.jsp";
        // service
        this.formsService.postForm(url, postData).then(function (response) {
            loader.classList.remove('active');
            if (!response.data || (response.data == 'invalid')) {
                analyticsService.dtmRecordSiteError('noerrorcode|invalid response');
                error.classList.add('active');
                thankYou.classList.add('active');
                success.classList.remove('active');
            }
            else {
                analyticsService.dtmFormComplete('complete', response.code);
                thankYou.classList.add('active');
                success.classList.add('active');
                error.classList.remove('active');
            }
        }).catch(function (response) {
            // service failed
            analyticsService.dtmRecordSiteError('noerrorcode|service failure occured|' + url);
            loader.classList.remove('active');
            fieldsContainer.classList.remove('hidden');
        });
    };
    return FormItemWinACar;
}(Base));
export { FormItemWinACar };



//////////////////
// WEBPACK FOOTER
// ./components-wpbbsa/form-item-win-a-car/form-item-win-a-car.component.ts
// module id = 991
// module chunks = 0